import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement, forwardRef, isValidElement, useCallback } from "react";
import { Text } from "sprout-ui-primitives";
import { Button } from "sprout-ui-dom/dist/Button";
import { media, themeGet } from "sprout-ui-theme";
import styled from "styled-components";
import { ACTIONS, useNavigationListContext } from "@sprout/list-navigation";
const PageToolbarItemButton = styled(Button)`
  position: relative;
  border-radius: 14px;
  flex-direction: column;
  justify-content: center;
  width: 64px;
  height: 64px;

  color: ${themeGet("colors.black.87")};

  ${media.target("pointer")} {
    :hover {
      background: #f7fafd;
      /* background: ${themeGet("colors.white.54")}; */
      /* background: ${themeGet("colors.black.6")}; */
      /* background: #91e5dd; */
    }
  }

  :active {
    background: #f7fafd;
    /* background: ${themeGet("colors.white.70")}; */
    /* background: ${themeGet("colors.black.12")}; */
    /* background: #81ccc4; */
  }

  transition: background 0.15s linear;
`;
const PageToolbarItemKeybinding = styled(Text)`
  display: none;

  top: 2px;
  right: 4px;
  position: absolute;

  ${media.up("medium", "pointer")} {
    display: initial;
  }
`;
const PageToolbarItemForwardedRef = /*#__PURE__*/ forwardRef(function PageToolbarItem(props, ref) {
    const { icon: iconProp , label: labelProp , onClick , onMouseDown , keybinding: keybindingProp , className , pulse ,  } = props;
    let label = labelProp;
    let icon = iconProp;
    let keybinding = keybindingProp;
    let action;
    if ("action" in props) {
        action = props.action;
        const actionSpec = ACTIONS.find(({ command  })=>command === props.action);
        label = label !== null && label !== void 0 ? label : actionSpec === null || actionSpec === void 0 ? void 0 : actionSpec.label;
        icon = icon !== null && icon !== void 0 ? icon : actionSpec === null || actionSpec === void 0 ? void 0 : actionSpec.icon;
        var ref1;
        keybinding = (ref1 = actionSpec === null || actionSpec === void 0 ? void 0 : actionSpec.keybindingForDisplay) !== null && ref1 !== void 0 ? ref1 : keybinding;
    }
    const { dispatchCommand  } = useNavigationListContext();
    const handleClick = useCallback((event)=>{
        if (onClick) onClick(event);
        if (action) dispatchCommand(action, null);
    }, [
        action,
        dispatchCommand,
        onClick
    ]);
    const iconToRender = icon ? /*#__PURE__*/ isValidElement(icon) ? icon : /*#__PURE__*/ createElement(icon) : undefined;
    return /*#__PURE__*/ _jsxs(PageToolbarItemButton, {
        onClick: handleClick,
        onMouseDown: onMouseDown,
        ref: ref,
        className: className,
        pulse: pulse,
        children: [
            keybinding && /*#__PURE__*/ _jsx(PageToolbarItemKeybinding, {
                fontSize: "13px",
                fontWeight: "medium",
                color: "black.60",
                as: "span",
                children: keybinding
            }),
            iconToRender,
            /*#__PURE__*/ _jsx(Text, {
                as: "span",
                fontWeight: "medium",
                fontSize: 1,
                mt: "2px",
                className: "PostPageToolbarItemLabel",
                children: label
            })
        ]
    });
});
export default PageToolbarItemForwardedRef;
